// extracted by mini-css-extract-plugin
module.exports = {"footer":"pricing_footer__EPPZ4"};